import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@app/../environments/environment';

@Injectable({
  providedIn: 'root'
})

export class TokenAuthService {

  constructor(
    private _http: HttpClient
  ) { }
  
  setUserData(user:any){
    localStorage.setItem('userLoc', user);
  }

  getJwtToken(){
    return localStorage.getItem('auth_token');
  }

  payload(token:any) {
    const jwtPayload = token.split('.')[1];
    return JSON.parse(atob(jwtPayload));
  }

  // User state
  isSignedin() {
    return localStorage.getItem('token') ? true : false;
  }

  // Destroy token
  destroyToken(){
    localStorage.removeItem('auth_token');
  }

}